import classes from "./footer.module.scss";
import { RouteComponentProps } from "react-router-dom";

const Footer = (props:RouteComponentProps) => {
  return <footer className={`footer ${classes.footer}`}></footer>;
};

export default Footer;
